import React, {Component} from 'react';
import ReactDOM from "react-dom";
import axios from 'axios';

import FormControl from '@material-ui/core/FormControl';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Button from '@material-ui/core/Button';

import clsx from 'clsx';
import {makeStyles, useTheme} from '@material-ui/core/styles';

import {DatePicker, MuiPickersUtilsProvider,} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

class Register extends Component {
    constructor(props) {
        super(props);

        this.state = {
            select_plan: false,
            choose_provider: true,
            provider: '',
            fill_user_data: false,
            fill_company_data: false,
            errors: {},
            show: false,
            show_password: false,
            countries: [],
            activities: [],
            user_message: '',

            //Form Data
            email: '',
            password: '',
            password_confirmation: '',
            user_form: {
                first_name: '',
                last_name: '',
                position: '',
                skype: '',
                mobile: '',
                language: [],
                agree_to_terms: false,
            },
            company_form: {},
            languages: [],
            plans: [],
            selectedPlan: 0
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleUserFormInputChange = this.handleUserFormInputChange.bind(this);
        this.handleUserFormCheckboxChange = this.handleUserFormCheckboxChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleCompanyCodeChange = this.handleCompanyCodeChange.bind(this);
        this.handleCompanyPeriodOfOperationChange = this.handleCompanyPeriodOfOperationChange.bind(this);
        this.handleCompanyFormInputChange = this.handleCompanyFormInputChange.bind(this);
        this.handleCompanyFormFileChange = this.handleCompanyFormFileChange.bind(this);
    }

    async componentDidMount() {
        await axios
            .post('/xhr/auth/register')
            .then(response => {
                this.processAxiosResponse(response);
            })
            .catch(error => {
                console.log(error);
            })

        this.setState({
            show: true
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    handleInputChange(event) {
        let errors = this.state.errors;

        errors[[event.target.name]] = null;

        this.setState({
            [event.target.name]: event.target.value,
            errors: errors
        })
    }

    handleUserFormInputChange(event) {
        let errors = this.state.errors;
        let form = this.state.user_form;

        errors[[event.target.name]] = null;
        form[[event.target.name]] = event.target.value;

        this.setState({
            errors: errors,
            form: form,
        })
    }

    handleUserFormCheckboxChange(event) {
        let errors = this.state.errors;
        let form = this.state.user_form;

        errors[[event.target.name]] = null;
        form[[event.target.name]] = !form[[event.target.name]];

        this.setState({
            errors: errors,
            form: form
        });
    }

    handleCompanyCodeChange(event) {
        let searchInput = event.target.value;

        let errors = this.state.errors;
        let form = this.state.company_form;

        errors[[event.target.name]] = null;
        form[[event.target.name]] = searchInput;

        this.setState({
            errors: errors,
            company_form: form,
        })

        // Clear Timeout if exists (keeps typing)
        if (this.searchTimeout) clearTimeout(this.searchTimeout);

        // Cancel previous request if it exists
        if (this.searchToken !== undefined) {
            this.searchToken.cancel();
        }

        this.searchToken = axios.CancelToken.source();

        if (searchInput.length > 2) {
            this.searchTimeout = setTimeout(() => {
                axios.post('/xhr/search/company', {
                    company_code: searchInput,
                }).then(response => {
                    if (response.status === 200) {
                        this.setState({
                            company_form: response.data
                        })
                    }
                }).catch(error => {
                    if (axios.isCancel(error)) {
                        console.log("canceled by previous requests");
                    }
                })
                    .then(response => {
                        // always executed
                    });
            }, 500);
        }
    }

    handleCompanyPeriodOfOperationChange(value) {

        let errors = this.state.errors;
        let form = this.state.company_form;

        errors['period_of_operation'] = null;
        form['period_of_operation'] = value.target.value;

        this.setState({
            errors: errors,
            company_form: form,
        })
    }

    handleCompanyFormInputChange(event) {
        let errors = this.state.errors;
        let form = this.state.company_form;

        errors[[event.target.name]] = null;
        form[[event.target.name]] = event.target.value;

        this.setState({
            errors: errors,
            company_form: form,
        })
    }

    handleCompanyFormFileChange(file) {
        let errors = this.state.errors;
        let form = this.state.company_form;

        errors['registration_document'] = null;
        form.registration_document = file;

        this.setState({
            ...this.state,
            errors: errors,
            company_form: form,
        })
    }

    handleFormSubmit(event) {
        event.preventDefault();

        let data = null;

        if (this.state.fill_user_data) {
            data = this.state.user_form;
        }

        if (this.state.fill_company_data) {
            data = this.state.company_form

            let formData = new FormData();

            Object.keys(data).map(key => {
                formData.append(key, Array.isArray(data[key]) ? JSON.stringify(data[key]) : data[key])
            })

            data = formData
        }

        if (this.state.select_plan) {
            data = {
                selectedPlan: this.state.selectedPlan
            }
        }

        if (this.state.provider) {
            if (this.state.provider !== 'local') {
                data = {provider: this.state.provider}
            } else {
                data = {
                    provider: this.state.provider,
                    email: this.state.email,
                    password: this.state.password,
                    password_confirmation: this.state.password_confirmation,

                }
            }
        }

        if (data) {
            axios
                .post('/xhr/auth/register', this.state.fill_company_data ? data : {...data})
                .then(response => {
                    this.processAxiosResponse(response);
                })
                .catch(error => {
                    if (error.response.data.errors) {
                        this.setState({
                            errors: error.response.data.errors
                        })
                    }
                })
        }
    }

    processAxiosResponse(response) {
        if (response.data.action === 'redirect') {
            window.location.href = response.data.url;
        }

        if (response.data.action === 'select_plan') {
            this.setState({
                ...this.state,
                fill_company_data: false,
                fill_user_data: false,
                select_plan: true,
                choose_provider: false,
                plans: response.data.plans
            })
        }

        if (response.data.action === 'fill_user_data') {
            this.setState({
                ...this.state,
                fill_company_data: false,
                fill_user_data: true,
                user_form: response.data.user_form,
                languages: response.data.languages,
                choose_provider: false,
                plans: response.data.plans
            })
        }

        if (response.data.action === 'fill_company_data') {
            this.setState({
                ...this.state,
                fill_user_data: false,
                fill_company_data: true,
                choose_provider: false,
                company_form: response.data.company_form,
            })
        }

        if (response.data.action === 'show_message') {
            this.setState({
                ...this.state,
                fill_user_data: false,
                fill_company_data: false,
                choose_provider: false,
                select_plan: false,
                user_message: response.data.message,
            })
        }

        if (response.data.countries) {
            this.setState({
                ...this.state,
                countries: response.data.countries,
            })
        }

        if (response.data.associations) {
            this.setState({
                ...this.state,
                associations: response.data.associations,
            })
        }

        if (response.data.activities) {
            this.setState({
                ...this.state,
                activities: response.data.activities,
            })
        }
    }

    renderChooseProvider() {
        const {choose_provider} = this.state;

        if (!choose_provider) return null;

        return (
            <React.Fragment>
                <h2>Registruoti naują paskyrą</h2>
                <Button className='reg-btn text-uppercase' style={{marginTop: '20px'}} variant="contained"
                        color="primary" disableElevation
                        onClick={() => this.setState({provider: 'local', choose_provider: false})}>Susikurti
                    vartotoją</Button>
                <Button type="submit" className='reg-btn text-uppercase' style={{marginTop: '20px'}} variant="contained"
                        color="primary" disableElevation
                        onClick={() => this.setState({provider: 'google'})}>Registruotis su Google</Button>
                <Button type="submit" className='reg-btn text-uppercase' style={{marginTop: '20px'}} variant="contained"
                        color="primary" disableElevation
                        onClick={() => this.setState({provider: 'microsoft'})}>Registruotis su Microsoft</Button>
            </React.Fragment>
        )
    }

    renderEmailWindow() {
        const {errors, choose_provider, provider, show_password} = this.state;
        const {email, password, password_confirmation} = this.state;

        if (!choose_provider && provider === 'local') {
            return (
                <React.Fragment>
                    <h2>Registruoti naują paskyrą</h2>
                    <TextField style={{width: '340px'}} type='email' label="Email" name='email'
                               onChange={this.handleInputChange} value={email}
                               error={!!(errors.email)} helperText={errors.email}/>

                    <FormControl style={{width: '340px', marginTop: '15px'}} error={!!(errors.password)}>
                        <InputLabel htmlFor="password">Password</InputLabel>
                        <Input autoFocus={true}
                               id='password'
                               type={show_password ? 'text' : 'password'}
                               name='password'
                               value={password}
                               onChange={this.handleInputChange}
                               endAdornment={
                                   <InputAdornment position="end">
                                       <IconButton aria-label="toggle password visibility"
                                                   onClick={() => this.setState({show_password: !show_password})}>
                                           {show_password ? <Visibility/> : <VisibilityOff/>}
                                       </IconButton>
                                   </InputAdornment>
                               }/>
                        {errors.password && (
                            <FormHelperText>{errors.password}</FormHelperText>
                        )}
                    </FormControl>

                    <FormControl style={{width: '340px', marginTop: '15px'}} error={!!(errors.password)}>
                        <InputLabel htmlFor="password_confirmation">Repeat password</InputLabel>
                        <Input autoFocus={true}
                               id='password_confirmation'
                               type={show_password ? 'text' : 'password'}
                               name='password_confirmation'
                               value={password_confirmation}
                               onChange={this.handleInputChange}
                               endAdornment={
                                   <InputAdornment position="end">
                                       <IconButton aria-label="toggle password visibility"
                                                   onClick={() => this.setState({show_password: !show_password})}>
                                           {show_password ? <Visibility/> : <VisibilityOff/>}
                                       </IconButton>
                                   </InputAdornment>
                               }/>
                        {errors.password && (
                            <FormHelperText>{errors.password}</FormHelperText>
                        )}
                    </FormControl>

                    <div style={{marginTop: '20px'}}>
                        <Button type='submit' className='reg-btn text-uppercase' style={{marginRight: '20px'}}
                                variant="contained"
                                color="primary" disableElevation>toliau</Button>
                    </div>
                </React.Fragment>
            )
        }

        return null;
    }

    getSelectStyles(name, array) {
        if (!array) return null;

        return {
            fontWeight:
                array.indexOf(name) === -1 ? 'regular' : 'bold',
        };
    }

    renderUserDataForm() {
        if (!this.state.fill_user_data) return null;

        const {user_form, languages, errors} = this.state;
        const ITEM_HEIGHT = 48;
        const ITEM_PADDING_TOP = 8;
        const MenuProps = {
            PaperProps: {
                style: {
                    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                    width: 250,
                },
            },
        };

        return (
            <React.Fragment>
                <h2 style={{marginBottom: '35px'}}>Atnaujinti informacija</h2>
                <TextField style={{width: '340px', margin: '10px'}} type='string' label="First name" name='first_name'
                           placeholder='john'
                           onChange={this.handleUserFormInputChange} value={user_form.first_name}
                           error={!!(errors.first_name)} helperText={errors.first_name} required/>

                <TextField style={{width: '340px', margin: '10px'}} type='string' label="Last name" name='last_name'
                           placeholder='doe'
                           onChange={this.handleUserFormInputChange} value={user_form.last_name}
                           error={!!(errors.last_name)} helperText={errors.last_name} required/>

                <TextField style={{width: '340px', margin: '10px'}} type='string' label="Position" name='position'
                           placeholder='CEO'
                           onChange={this.handleUserFormInputChange} value={user_form.position}
                           error={!!(errors.position)} helperText={errors.position}/>

                <TextField style={{width: '340px', margin: '10px'}} type='string' label="Skype" name='skype'
                           placeholder='JhonD'
                           onChange={this.handleUserFormInputChange} value={user_form.skype}
                           error={!!(errors.skype)} helperText={errors.skype}/>

                <TextField style={{width: '340px', margin: '10px'}} type='phone' label="Contact phone" name='mobile'
                           placeholder='+1 155 5154532'
                           onChange={this.handleUserFormInputChange} value={user_form.mobile}
                           error={!!(errors.mobile)} helperText={errors.mobile} required/>

                <div>
                    <FormControl style={{width: '340px', margin: '10px'}}>
                        <InputLabel id="languages-lable">Languages</InputLabel>
                        <Select
                            name='languages'
                            labelId="languages-lable"
                            multiple
                            required
                            value={user_form.languages}
                            onChange={this.handleUserFormInputChange}
                            renderValue={
                                (selected) => (
                                    <div style={{display: 'flex', flexWrap: 'wrap', paddignLeft: '5px'}}>
                                        {selected.map((item, index) => (
                                            <Chip style={{margin: '5px 5px 0 0', borderRadius: '5px'}} key={index}
                                                  label={item.value}/>
                                        ))}
                                    </div>
                                )
                            }
                            MenuProps={MenuProps}>
                            {
                                languages && languages.map((item, index) => (
                                    <MenuItem key={index} value={item}
                                              style={this.getSelectStyles(item, user_form.languages)}>{item.value}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </div>

                <div style={{marginTop: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <Checkbox name="agree_to_terms" color="primary"
                              required
                              checked={user_form.agree_to_terms}
                              onChange={this.handleUserFormCheckboxChange}
                    />
                    Agree to <a style={{margin: '0 5px'}} target="_blank" href="https://viagidas.mtds.lt/lt/tos"> Terms
                    of use </a> and <a style={{margin: '0 5px'}} target="_blank"
                                       href="https://viagidas.mtds.lt/lt/privacy"> Privacy policy </a>
                </div>

                <div style={{marginTop: '35px', marginBottom: '25px'}}>
                    <Button variant="contained" style={{marginRight: '15px'}} disableElevation>Atgal</Button>
                    <Button type='submit' variant="contained" color="primary" disableElevation>Toliau</Button>
                </div>
            </React.Fragment>
        )
    }

    renderCompanyDataForm() {
        if (!this.state.fill_company_data) return null;

        const {company_form, errors, countries, associations, activities} = this.state;

        const ITEM_HEIGHT = 48;
        const ITEM_PADDING_TOP = 8;
        const MenuProps = {
            PaperProps: {
                style: {
                    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                    width: 250,
                },
            },
        };

        const useStyles = makeStyles((theme) => ({
            formControl: {
                margin: theme.spacing(1),
                minWidth: 120,
                maxWidth: 300,
            },
            chips: {
                display: 'flex',
                flexWrap: 'wrap',
            },
            chip: {
                margin: 2,
            },
            noLabel: {
                marginTop: theme.spacing(3),
            },
        }));

        return (
            <React.Fragment>
                <h2 style={{marginBottom: '35px'}}>Atnaujinti informacija</h2>
                <TextField style={{width: '300px', margin: '10px'}} label="Company code" placeholder='00000000'
                           type='string' name='company_code'
                           value={company_form.company_code} onChange={this.handleCompanyCodeChange}
                           error={!!(errors.company_code)} helperText={errors.company_code} required/>

                <TextField style={{width: '300px', margin: '10px'}} label="Company name" placeholder='My Company, LLC'
                           type='string' name='company_name'
                           value={company_form.company_name} onChange={this.handleCompanyFormInputChange}
                           error={!!(errors.company_name)} helperText={errors.company_name} required
                           InputProps={{readOnly: !!company_form.id}}/>

                <TextField style={{width: '300px', margin: '10px'}} label="VAT number" placeholder='XX465165465154651'
                           type='string' name='company_vat'
                           value={company_form.company_vat} onChange={this.handleCompanyFormInputChange}
                           error={!!(errors.company_vat)} helperText={errors.company_vat}
                           InputProps={{readOnly: !!company_form.id}}/>

                <TextField style={{width: '300px', margin: '10px'}} label="Company email" placeholder='info@company.com'
                           type='email' name='company_email'
                           value={company_form.company_email} onChange={this.handleCompanyFormInputChange}
                           error={!!(errors.company_email)} helperText={errors.company_email}
                           InputProps={{readOnly: !!company_form.id}}/>

                <TextField style={{width: '300px', margin: '10px'}} label="Company phone" placeholder='+1 11 111 1111'
                           type='phone' name='company_phone'
                           value={company_form.company_phone} onChange={this.handleCompanyFormInputChange}
                           error={!!(errors.company_phone)} helperText={errors.company_phone}
                           InputProps={{readOnly: !!company_form.id}}/>

                <TextField style={{width: '300px', margin: '10px'}} label="Company fax" placeholder='+1 11 111 1111'
                           type='phone' name='company_fax'
                           value={company_form.company_fax} onChange={this.handleCompanyFormInputChange}
                           error={!!(errors.company_fax)} helperText={errors.company_fax}
                           InputProps={{readOnly: !!company_form.id}}/>

                <TextField style={{width: '300px', margin: '10px'}} label="Website"
                           placeholder='https://www.company.com' type='string' name='company_website'
                           value={company_form.company_website} onChange={this.handleCompanyFormInputChange}
                           error={!!(errors.company_website)} helperText={errors.company_website}
                           InputProps={{readOnly: !!company_form.id}}/>

                <FormControl required style={{width: '300px', margin: '10px'}}>
                    <InputLabel htmlFor="company_country">Country</InputLabel>
                    <NativeSelect
                        value={company_form.company_country}
                        onChange={this.handleCompanyFormInputChange}
                        inputProps={{name: 'company_country', id: 'company_country', disabled: !!company_form.id}}>
                        <option aria-label="None" value=""/>
                        {
                            countries && countries.map((item, index) => (
                                <option key={index} value={item.code}>{item.label}</option>
                            ))
                        }
                    </NativeSelect>
                </FormControl>

                <TextField style={{width: '300px', margin: '10px'}} label="City" placeholder='Vilnius' type='string'
                           name='company_city'
                           value={company_form.company_city} onChange={this.handleCompanyFormInputChange}
                           error={!!(errors.company_city)} helperText={errors.company_city} required
                           InputProps={{readOnly: !!company_form.id}}/>

                <TextField style={{width: '300px', margin: '10px'}} label="Address" placeholder='Street 123'
                           type='string' name='company_address'
                           value={company_form.company_address} onChange={this.handleCompanyFormInputChange}
                           error={!!(errors.company_address)} helperText={errors.company_address} required
                           InputProps={{readOnly: !!company_form.id}}/>

                <TextField style={{width: '300px', margin: '10px'}} label="Post code" placeholder='00000' type='string'
                           name='company_post_code'
                           value={company_form.company_post_code} onChange={this.handleCompanyFormInputChange}
                           error={!!(errors.company_post_code)} helperText={errors.company_post_code} required
                           InputProps={{readOnly: !!company_form.id}}/>

                <div style={{
                    width: '300px',
                    margin: '10px',
                    display: 'inline-flex',
                    padding: 0,
                    position: 'relative',
                    flexDirection: 'column',
                    verticalAlign: 'top'
                }}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <TextField
                            style={{width: '100%'}}
                            id="date"
                            label="Period of operation"
                            type="date"
                            placeholder={'0000-00-00'}
                            value={company_form.period_of_operation || ''}
                            onChange={this.handleCompanyPeriodOfOperationChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </div>

                <FormControl className={'classes.formControl'} style={{width: '300px', margin: '10px'}}>
                    <InputLabel id="activity-label">Type of activity</InputLabel>
                    <Select labelId="activity-label"
                            multiple required disabled={!!company_form.id}
                            name='type_of_activity'
                            value={company_form.type_of_activity}
                            onChange={this.handleCompanyFormInputChange}
                            renderValue={(selected) => (
                                <div style={{display: 'flex', flexWrap: 'wrap', paddignLeft: '5px'}}>
                                    {
                                        selected.map((item, index) => (
                                            <Chip style={{margin: '5px 5px 0 0', borderRadius: '5px'}} key={index}
                                                  label={item.name}/>
                                        ))
                                    }
                                </div>
                            )}
                            MenuProps={MenuProps}>
                        {
                            activities && activities.map((item, index) => (
                                <MenuItem key={index} value={item}
                                          style={this.getSelectStyles(item, company_form.type_of_activity)}>
                                    {item.name}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
                <FormControl className={'classes.formControl'} style={{width: '300px', margin: '10px'}}>
                    <InputLabel id="association-label">Associations</InputLabel>
                    <Select labelId="association-label"
                            multiple disabled={!!company_form.id}
                            name='associations'
                            value={company_form.associations}
                            onChange={this.handleCompanyFormInputChange}
                            renderValue={(selected) => (
                                <div style={{display: 'flex', flexWrap: 'wrap', paddignLeft: '5px'}}>
                                    {
                                        selected.map((value, index) => (
                                            <Chip style={{margin: '5px 5px 0 0', borderRadius: '5px'}} key={index}
                                                  label={value.name} className={'classes.chip'}/>
                                        ))
                                    }
                                </div>
                            )}
                            MenuProps={MenuProps}>
                        {
                            associations && associations.map((item, index) => (
                                <MenuItem key={index} value={item}
                                          style={this.getSelectStyles(item, company_form.associations)}>
                                    {item.name}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>

                {
                    company_form.id === undefined && <div style={{width: '100%', margin: '15px auto'}}>
                        <div>Įkelkite įmonės registracijos pažymėjimą*:</div>
                        <input type="file"
                               onChange={(e) => this.handleCompanyFormFileChange(e.target.files[0])}
                               required
                        />
                    </div>
                }

                <div style={{marginTop: '35px', marginBottom: 25}}>
                    {/*<Button variant="contained" style={{marginRight: '15px'}} disableElevation>Atgal</Button>*/}
                    <Button type='submit' variant="contained" color="primary" disableElevation>Toliau</Button>
                </div>
            </React.Fragment>
        )
    }

    renderSubscriptionForm() {
        if (!this.state.select_plan) return null;

        return (
            <React.Fragment>
                <h2 style={{marginBottom: '35px'}}>Pasirinkti planą</h2>

                {this.state && this.state.plans && this.state.plans.map(plan => <div key={plan.id}>
                        <div className={`card plans-card`}>
                            <div className="row">
                                <div className="col-12">
                                    <h3>{plan.name}</h3>
                                </div>
                                <div className="col-12">
                                    <div>{plan.description}</div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6"><small className="text-muted">Users</small></div>
                                <div className="col-6 text-center"><span>
                                    {plan.max_users ? `${plan.min_users}-${plan.max_users}` : `${plan.min_users}+`}
                                </span></div>
                            </div>
                            <div className="row">
                                <div className="col-6"><small className="text-muted">Free ads a month</small></div>
                                <div className="col-6 text-center"><span>{plan.ad_free_count}</span></div>
                            </div>
                            <div className="row">
                                <div className="col-6"><small className="text-muted">Ad submit fee</small></div>
                                <div className="col-6 text-center"><span>{plan.ad_submit_fee} Eur</span></div>
                            </div>
                            <div className="row">
                                <div className="col-6"><small className="text-muted">Winners fee</small></div>
                                <div className="col-6 text-center"><span>{plan.winner_fee_percent} % * </span></div>
                            </div>

                            {
                                plan.monthly_discount &&
                                <div className="row">
                                    <div className="col-6"><small className="text-muted">Monthly discount</small></div>
                                    <div className="col-6 text-center"><span> {plan.monthly_discount}% </span></div>
                                </div>
                            }
                            {
                                plan.ad_submit_fee_discount &&
                                <div className="row">
                                    <div className="col-6"><small className="text-muted">Ad submit fee discount</small>
                                    </div>
                                    <div className="col-6 text-center"><span>{plan.ad_submit_fee_discount}%</span></div>
                                </div>
                            }
                            {
                                plan.winner_fee_discount &&
                                <div className="row">
                                    <div className="col-6"><small className="text-muted">Winner fee discount</small>
                                    </div>
                                    <div className="col-6 text-center"><span>{plan.winner_fee_discount}%</span></div>
                                </div>
                            }

                            <div className="row">
                                <div className="col-6"><small className="text-muted"> Eur / month</small></div>
                                <div className="col-6 text-center"><span
                                    style={{fontWeight: 'bold'}}>{plan.monthly_fee.toFixed(2)}</span></div>
                            </div>

                            <div style={{height: "100px"}}>
                                <small className="text-muted">* no less than {plan.winner_fee_min} euros and no more
                                    than {plan.winner_fee_max} euros from the transaction value</small>
                            </div>

                            <div>
                                <Checkbox checked={plan.id === this.state.selectedPlan}
                                          onClick={() => this.setState({...this.state, selectedPlan: plan.id})}/>
                            </div>
                        </div>
                    </div>
                )}

                <div style={{marginTop: '35px', paddingBottom: 50}}>
                    {/*<Button variant="contained" style={{marginRight: '15px'}} disableElevation>Atgal</Button>*/}
                    <Button type='submit' variant="contained" color="primary" disableElevation>Toliau</Button>
                </div>
            </React.Fragment>
        )
    }

    renderUserMessage() {
        if (!this.state.user_message) return null;

        return (
            <React.Fragment>
                <h2 style={{marginBottom: '35px'}}>{this.state.user_message}</h2>
            </React.Fragment>
        )
    }

    render() {
        const {fill_user_data, fill_company_data, select_plan} = this.state;

        return (
            <div className="login-box"
                 style={(fill_user_data || fill_company_data || select_plan) ? {paddingTop: '100px'} : {width: '400px'}}>
                {this.state.show && (
                    <React.Fragment>
                        <form onSubmit={this.handleFormSubmit} autoComplete='off'>
                            {this.renderChooseProvider()}
                            {this.renderEmailWindow()}
                            {this.renderUserDataForm()}
                            {this.renderCompanyDataForm()}
                            {this.renderSubscriptionForm()}
                            {this.renderUserMessage()}
                        </form>
                    </React.Fragment>
                )}
            </div>
        )
    }
}

ReactDOM.render(<Register/>, document.getElementById("auth"));